package com.partejar.app.feature.home.presentation

import com.partejar.app.feature.home.data.HomeAttentionLevel
import com.partejar.app.feature.home.data.HomePendingType

sealed interface HomeUiState {
    data object Loading : HomeUiState

    data class Content(
        val userName: String,
        val greeting: HomeGreeting,
        val dateLabel: String,
        val attentionItems: List<HomeAttentionItemUi>,
        val upcomingPregnancies: List<HomePregnancyUi>,
        val todayAppointments: List<HomeAppointmentUi>
    ) : HomeUiState

    data object Empty : HomeUiState

    data class Error(val message: String) : HomeUiState
}

data class HomeGreeting(
    val period: HomeGreetingPeriod,
    val message: String
)

enum class HomeGreetingPeriod {
    MORNING,
    AFTERNOON,
    NIGHT
}

data class HomeAttentionItemUi(
    val id: String,
    val summary: String,
    val quantity: Int = 1,
    val level: HomeAttentionLevel = HomeAttentionLevel.ATTENTION,
    val type: HomePendingType? = null
)

data class HomePregnancyUi(
    val id: String,
    val name: String,
    val babyName: String,
    val gestationalWeeks: Int,
    val gestationalDays: Int,
    val dueDate: String,
    val responsible: String?,
    val actionRequired: String?
)

data class HomeAppointmentUi(
    val id: String,
    val time: String,
    val type: String,
    val relatedPerson: String
)
